import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import CURATED_SHOPS from '@/mocks/cureatedShops';
import { RESULT_TYPES } from './data/yangbokResultTypes';

import ResultHero from './components/ResultHero';
import TypeExplanation from './components/TypeExplanation';
import StyleBars from './components/StyleBars';
import MainRecommendation from './components/MainRecommendation';
import UpgradeConsideration from './components/UpgradeConsideration';
import SituationGuide from './components/SituationGuide';
import ShopCards from './components/ShopCards';
import ConsultationCTA from './components/ConsultationCTA';

const DEFAULT_RESULT_KEY = 'semiBespoke';

function getResultByKey(resultKey?: string) {
  return (
    RESULT_TYPES.find((item) => item.key === resultKey) ||
    RESULT_TYPES.find((item) => item.key === DEFAULT_RESULT_KEY) ||
    RESULT_TYPES[0]
  );
}

export default function YangbokQuestionResultPage() {
  const navigate = useNavigate();
  const { resultKey } = useParams<{ resultKey?: string }>();
  console.log('result key: ', resultKey)
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 60);
    return () => clearTimeout(timer);
  }, []);

  const result = useMemo(() => getResultByKey(resultKey), [resultKey]);

  console.log(result)

  const displayShops = useMemo(() => {
    const matchedShopIds = result.matchedShopIds || [];

    const matchedShops = CURATED_SHOPS.filter((shop) =>
      matchedShopIds.includes(shop.id)
    );

    return matchedShops.length > 0 ? matchedShops : CURATED_SHOPS.slice(0, 2);
  }, [result.matchedShopIds]);

  const shopItems = useMemo(() => {
    return displayShops.map((shop) => {
      const whyMatch =
        shop.recommendation.length > 90
          ? `${shop.recommendation.slice(0, 90)}...`
          : shop.recommendation;

      return {
        id: shop.id,
        name: shop.name,
        image: shop.image,
        description: shop.subtitle,
        whyMatch,
        tags: shop.tags.slice(0, 3),
        reviewSnippet: shop.reviewSnippet,
        reviews: shop.reviews,
      };
    });
  }, [displayShops]);

  const handleConsult = () => {
    navigate('/yangbok');
  };

  const handleRestart = () => {
    navigate('/yangbok');
  };

  const handleShareFallback = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      // eslint-disable-next-line no-alert
      alert('링크가 복사되었어요.');
    } catch {
      // eslint-disable-next-line no-alert
      alert('링크 복사에 실패했어요.');
    }
  };

  return (
    <main
      className={`min-h-screen bg-cream transition-opacity duration-500 ${
        loaded ? 'opacity-100' : 'opacity-0'
      }`}
    >
      <ResultHero
        typeName={result.title}
        typeDescription={result.summary}
        recommendation={result.recommendation}
        rarityPercent={result.rarityPercent}
      />

      <TypeExplanation
        summary={result.typeExplanation.summary}
        paragraphs={result.typeExplanation.paragraphs}
      />

      <StyleBars items={result.styleBars} />

      <MainRecommendation
        title={result.mainRecommendation.title}
        description={result.mainRecommendation.description}
        reasons={result.mainRecommendation.reasons}
      />

      <UpgradeConsideration conditions={result.upgradeConditions} />

      <SituationGuide cards={result.situationCards} />

      <ShopCards shops={shopItems} />

      <ConsultationCTA
        onConsult={handleConsult}
        onRestart={handleRestart}
        onShare={handleShareFallback}
      />
    </main>
  );
}